import React, { useState, useEffect} from "react";

import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  CssBaseline,
  Divider,
  Typography,
  Paper,
  Container,
  Card,
  CardContent,
  CardActions,
  Button, TextField,
  Grid,Dialog, DialogTitle, DialogContent, DialogActions
} from "@mui/material";
// import {
//   Dashboard as DashboardIcon,
//   AccountBalance as PaymentIcon,
//   AccountBalanceWallet as TranHisIcon,
//   AccountBalanceWallet as AccountBalanceWalletIcon,
//   Forum as AllComplaintIcon,
//   Help as HelpIcon,
//   Report as ReportIcon,
//   ChevronLeft as ChevronLeftIcon,
//   Menu as MenuIcon,
//   AccountCircle as LogoutIcon,
//   LegendToggleRounded
// } from "@mui/icons-material";
import AuthApi4 from "../services/authApi";
import TvIcon from '@mui/icons-material/Tv';
import HouseIcon from '@mui/icons-material/House';
// import Sidebar from "../sidebar/Sidebar";
// import Navbar from "../sidebar/Navbar";
import Navbar from "../sidebar/SideNavbar";
import Footer from "../sidebar/Footer";

export default function Dashboard() {
  const navigate = useNavigate();
  const [lcowallet, setlcowallet] = useState("");
  const [openWallet, setOpenWallet] = useState(false);
  const [walletAmount, setWalletAmount] = useState("");
  const [errors, setErrors] = useState({});

  const [totalBoxes, setTotalBoxes] = useState(0);
  const [activeBoxes, setActiveBoxes] = useState(0);
  const [inactiveBoxes, setInactiveBoxes] = useState(0);
const [loading, setLoading] = useState(true);
  useEffect(() => {
    initializeDashboard();
    getlcowallet();
    stbinfo();
    
  }, [navigate]);

  const handleClickOpenWallet = () => {
    setOpenWallet(true);
    // setWalletAmount(lcowallet);
  };

  const handleWalletClose = () => {
    setOpenWallet(false);
  };

  const handleWalletAmountChange = (event) => {
    // Ensure only numbers are entered
    const value = event.target.value;
    if (/^\d*$/.test(value)) {
      setWalletAmount(value);
      setErrors({});
    }
  };


  const isLoggedIn = localStorage.getItem("isLoggedIn");
  if (isLoggedIn === null) {
    navigate("/login");
  }

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      setWalletAmount(event.target.value);

      event.preventDefault();    }
  };

 const initializeDashboard = async () => {

  const alreadyImported = localStorage.getItem("BULK_IMPORTED");

  // 👉 If already imported, skip API call
  if (alreadyImported === "Y") {
    console.log("SKIPPING INIT API — Already Imported");
    setLoading(false);
    return;
  }

  // 👉 Otherwise call the API
  let payload = {
    PHONE: localStorage.getItem("phoneNumber"),
    operator_id: parseInt(localStorage.getItem("ownerId")),
    FLAG: "A"
  };

  try {
    const response = await fetch(
      "https://api.mobiezy.in/php/NXTV2/hotel_import.php",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      }
    );

    const json = await response.json();
    console.log("INIT API RESPONSE", json);

    // Mark as imported
    localStorage.setItem("BULK_IMPORTED", "Y");

  } catch (error) {
    console.log("INIT API ERROR", error);
  }

  // Hide loader after everything
  setLoading(false);
};


  const stbinfo = async(event) =>{
    let data = {
      records: [
        {
          phone: localStorage.getItem("phoneNumber"),
          operator_id: parseInt(localStorage.getItem("ownerId")),
          CUST_ID:localStorage.getItem("payment_cust_num"),
          type:"stbInfo"
        },
      ],
    };
    console.log(data);
    await AuthApi4.stbinfo(data)
      .then((response) => {
        console.log(response);
        console.log(response.data.stbdetails[0]);
        let total_value=response.data.stbdetails[0].L_TOTAL_BOXES;
        setTotalBoxes(total_value===null? 0:total_value);
        let active_value=response.data.stbdetails[0].L_ACTIVE_BOXES;
        setActiveBoxes(active_value===null? 0:active_value);
        let inactive_value=response.data.stbdetails[0].L_INACTIVE_BOXES;
        setInactiveBoxes(inactive_value===null? 0:inactive_value);
      })
      .catch((e) => {
        console.log("STB INFO Error");

        console.log(e);
      });
  }
  


  const getlcowallet = async () => {
    let data =  {
      records: [
      {
        CUST_ID:localStorage.getItem("payment_cust_num"),
        type:"wallet"
          },
        ],
      }
    console.log(data);
    await AuthApi4.stbinfo(data)
      .then((response) => {
        console.log(response);
        let billTotal = 0;
        if (response.data.stbdetails[0].bill_total >= 0){
          setlcowallet(response.data.stbdetails[0].bill_total);
        } else {
          billTotal=-(response.data.stbdetails[0].bill_total);
          setlcowallet(billTotal); 
        }
      })
      .catch((e) => {
        console.log("Wallet Error");

        console.log(e);
      });
  };

  const handleAddWalletAmount= async() => {
    console.log(walletAmount);
    if (walletAmount === "") {
      setErrors({
        walletAmount: <font color="red">Amount cannot be empty.</font>,
      });
      return;
    }else{
       let tran =
        "SPTNXTHSUBWEB" +
        parseInt(localStorage.getItem("ownerId")) +
        Date.now();
      let data = JSON.stringify({
        AMOUNT: walletAmount,
        PHONE: localStorage.getItem("op_phone"),
        OPERATOR_ID: localStorage.getItem("ownerId"),
        flag: "E",
        CUST_NUM: localStorage.getItem("payment_cust_num"),
        CUST_NAME: localStorage.getItem("payment_cust_name"),
        tran_id: tran,
      });
      console.log(data);
      await AuthApi4.cashfree_init(data)
        .then((response) => {
          if (response.data.p_out_mssg_flg === "S") {
            window.location.href =
              "https://apps.mobiezy.in/CASHFREE/HOTEL/RAJIT/cashfree_ui.php?paymentSessionId=" +
              response.data.payment_session_id;

            //  window.location.href = "https://mobicollector.com/cashfree/checkout.php?PHONE=" + localStorage.getItem("phoneNumber")+ "&amount=" + amount_st+ "&name=" + "NA"+"&op_id="+parseInt(localStorage.getItem("ownerId"))+"&tran_id="+tran;
          } else {
            handleWalletClose(true);
          //  setButtonLoading(false);
             Swal.fire({
                    icon: 'warning',
                    title: 'Error',
                    text: response.data.p_out_mssg
                  });
          }
        })
        .catch((e) => {
          console.log(e);
        });
    }
  };

  return (
  <>
    {loading ? (
      // -----------------------
      // LOADING SCREEN
      // -----------------------
      <div
        style={{
          height: "100vh",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          background: "#ffffff",
        }}
      >
       <img src="/hotel-loader.gif" alt="loading" style={{ width: 300, height: 300 }} />

        <h1 style={{ marginTop: 10, color: "#ff8c00" }}>Loading...</h1>
      </div>
    ) : (
      // --------------------------
      // MAIN PAGE CONTENT
      // --------------------------
      <div style={{ display: "flex", background: "#F5F5F5" }}>
        <CssBaseline />
        <Navbar />

        <main style={{ flexGrow: 1, padding: "0px", minHeight: "100vh" }}>
          <Container
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              minHeight: "calc(100vh - 64px)",
              margin: "auto",
              maxWidth: "lg",
            }}
          >
            <Box
              sx={{
                width: "100%",
                maxWidth: "800px",
                padding: 0,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Grid container justifyContent="center">
                <Grid item xs={12}>
                  <Paper
                    sx={{
                      padding: 2,
                      textAlign: "center",
                      borderRadius: 4,
                      boxShadow: 6,
                      width: "100%",
                      marginBottom: 5,
                    }}
                  >
                    <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                      <HouseIcon sx={{ marginRight: 1, color: "#ff8c00" }} />
                      {localStorage.getItem("payment_cust_name")}
                    </Typography>

                    <Grid item xs={12}>
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginTop: 3,
                          width: "100%",
                        }}
                      >
                        <Typography variant="body1">
                          <Typography component="span" sx={{ fontWeight: "bold" }}>
                            Mobile Number:
                          </Typography>{" "}
                          {localStorage.getItem("phoneNumber")}
                        </Typography>

                        <Typography variant="body1">
                          <Typography component="span" sx={{ fontWeight: "bold" }}>
                            Wallet Balance:
                          </Typography>{" "}
                          {lcowallet}
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={handleClickOpenWallet}
                            sx={{ marginLeft: 2 }}
                          >
                            Add
                          </Button>
                        </Typography>

                        {/* Wallet Dialog */}
                        <Dialog
                          open={openWallet}
                          onClose={handleWalletClose}
                          aria-labelledby="wallet-dialog-title"
                          sx={{
                            "& .MuiDialog-paper": {
                              minWidth: 300,
                              maxWidth: "80%",
                              margin: "auto",
                            },
                          }}
                        >
                          <DialogTitle
                            id="wallet-dialog-title"
                            sx={{ textAlign: "center", color: "#ff8c00" }}
                          >
                            Add Amount
                          </DialogTitle>

                          <DialogContent>
                            <Typography sx={{ marginBottom: 2 }}>Enter Amount:</Typography>

                            <TextField
                              label="Amount"
                              variant="outlined"
                              fullWidth
                              value={walletAmount}
                              id="walletAmount"
                              onKeyDown={handleKeyDown}
                              onChange={handleWalletAmountChange}
                              error={!!errors.walletAmount}
                              helperText={errors.walletAmount}
                              inputProps={{
                                inputMode: "numeric",
                                pattern: "[0-9]*",
                              }}
                            />
                          </DialogContent>

                          <DialogActions sx={{ justifyContent: "center" }}>
                            <Button
                              onClick={handleAddWalletAmount}
                              sx={{
                                backgroundColor: "#ff8c00",
                                color: "#fff",
                                "&:hover": { backgroundColor: "#e07b00" },
                              }}
                            >
                              Submit
                            </Button>
                          </DialogActions>
                        </Dialog>
                      </Box>
                    </Grid>
                  </Paper>
                </Grid>

                {/* ------------------- */}
                {/* Stats Cards Section */}
                {/* ------------------- */}
                <Grid container spacing={3}>
                  {/* Total Boxes */}
                  <Grid item xs={12} md={4}>
                    <Card
                      sx={{
                        height: "100%",
                        backgroundColor: "#f5f5f5",
                        borderRadius: 4,
                        boxShadow: 6,
                      }}
                    >
                      <CardContent sx={{ flexGrow: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <TvIcon sx={{ marginRight: 1, color: "#1E90FF" }} />
                          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                            Total Boxes
                          </Typography>
                        </Box>
                      </CardContent>
                      <Divider />
                      <CardActions sx={{ justifyContent: "flex-end", padding: 2 }}>
                        <Typography variant="h6">{totalBoxes}</Typography>
                      </CardActions>
                    </Card>
                  </Grid>

                  {/* Active Boxes */}
                  <Grid item xs={12} md={4}>
                    <Card
                      sx={{
                        height: "100%",
                        backgroundColor: "#f5f5f5",
                        borderRadius: 4,
                        boxShadow: 6,
                      }}
                    >
                      <CardContent sx={{ flexGrow: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <TvIcon sx={{ marginRight: 1, color: "#32CD32" }} />
                          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                            Active
                          </Typography>
                        </Box>
                      </CardContent>
                      <Divider />
                      <CardActions sx={{ justifyContent: "flex-end", padding: 2 }}>
                        <Typography variant="h6">{activeBoxes}</Typography>
                      </CardActions>
                    </Card>
                  </Grid>

                  {/* Suspended Boxes */}
                  <Grid item xs={12} md={4}>
                    <Card
                      sx={{
                        height: "100%",
                        backgroundColor: "#f5f5f5",
                        borderRadius: 4,
                        boxShadow: 6,
                      }}
                    >
                      <CardContent sx={{ flexGrow: 1 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <TvIcon sx={{ marginRight: 1, color: "#FF4500" }} />
                          <Typography variant="h5" sx={{ fontWeight: "bold" }}>
                            Suspended
                          </Typography>
                        </Box>
                      </CardContent>
                      <Divider />
                      <CardActions sx={{ justifyContent: "flex-end", padding: 2 }}>
                        <Typography variant="h6">{inactiveBoxes}</Typography>
                      </CardActions>
                    </Card>
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </Container>

          <Footer />
        </main>
      </div>
    )}
  </>
);

}
